// used to parsed datetime to input type datetime-local value (2024-10-01T07:12:48.210016Z -> 2024-10-01T07:12)
export function formatDateToDatetimeLocal(dateString: string) {
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');  // Los meses son base 0
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

// 19/10/1997 -> 27 (años)
export const getUserYears = (date: string): number => {
  const birthDate = new Date(date);
  const currentDate = new Date();
  const yearsDiff = currentDate.getFullYear() - birthDate.getFullYear();

  const monthDiff = currentDate.getMonth() - birthDate.getMonth();
  const dayDiff = currentDate.getDate() - birthDate.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    return yearsDiff - 1;
  }

  return yearsDiff;
};

export const printEventDate = (startEvent: string, endEvent: string): string => {
  const startDate = new Date(startEvent);
  const endDate = new Date(endEvent);

  const humanMonth = endDate.toLocaleDateString('es-ES', { month: 'long' });

  // Event is in the same day
  if (
    startDate.getDate() === endDate.getDate() 
    && startDate.getMonth() === endDate.getMonth() 
    && startDate.getFullYear() === endDate.getFullYear()
  ) {
    return `${startDate.getDate().toString()} ${humanMonth} ${startDate.getFullYear()}`;
  }

  return `${startDate.getDate().toString()} - ${endDate.getDate().toString()} de ${humanMonth} ${endDate.getFullYear()}`
}